import { ServiceRequestService } from './../../../../../Services/service-request.service';
import { Subscription } from 'rxjs';
import { ServiceRequest } from './../../../../../../back-office/Models/ServiceRequest';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-reply-step-form',
  templateUrl: './reply-step-form.component.html',
  styleUrls: ['./reply-step-form.component.scss']
})
export class ReplyStepFormComponent implements OnInit , OnDestroy {

  @Input() Index;
  @Input() isActive;

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];

  constructor(
    private requestService: ServiceRequestService,
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.request.reply.replyItems = this.request.reply.replyItems.filter(item => !item.solutionStep.restricted);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getPDF(){

  }

}
